import Header from "../../../layouts/header/Header";
import Footer from "../../../layouts/footer/Footer";
import GreenCheckIcon from "../../../icons/GreenCheckIcon";
import PYPDetailsCard from "./PYPDetailsCard";
import PYPDetailsCard2 from "./PYPDetailsCard2";
import { getPYPData } from "services";
import { useRouter } from "next/router";
import { useState, useEffect } from "react";
import ImageSvg from "../../../icons/PostYourProperty/ImageSvg";
import MessageSvg from "../../../icons/PostYourProperty/MessageSvg";
import SealCheckIcon from "../../../icons/PostYourProperty/SealCheckSvg";
export const PYPSuccessPage = () => {
  const router = useRouter();
  const [data, setData] = useState<any>({});
  const [role, setRole] = useState<any>("");
  const { uuid } = router.query;
  const [title, setTitle] = useState("");
  const [firstImage, setFirstImage] = useState<any>();

  const extractData = (data: any) => {
    let reserve_price = data?.reservePrice
      ? "Rs. " + data?.reservePrice
      : undefined;
    let basePrice = data?.basePriceProposedLastRp
      ? "Rs. " + data?.basePriceProposedLastRp
      : undefined;
    let institution = data?.instituteName?.label;
    let property_type = data?.propertyType?.title;
    let sub_type = data?.subPropertyType?.title;
    let bidding_start =
      data?.dateOfAuction?.date && data?.dateOfAuction?.time
        ? data?.dateOfAuction?.date + " " + data?.dateOfAuction?.time
        : undefined;
    let bidding_end =
      data?.auctionEndDate?.date && data?.auctionEndDate?.time
        ? data?.auctionEndDate?.date + " " + data?.auctionEndDate?.time
        : undefined;
    let city = data?.city?.label;
    let location = data?.locality;
    let frontImage =
      data?.propertyPhotos && data?.propertyPhotos[0]
        ? data?.propertyPhotos[0]
        : [];

    let builtup_area = data?.builtUpArea + " sq ft";

    setData({
      reserve_price: reserve_price,
      base_price: basePrice,
      institution: institution,
      property_type: property_type,
      sub_type: sub_type,
      bidding_start: bidding_start,
      location: city,
      builtup_area: builtup_area,
      bidding_end: bidding_end,
    });

    let newTitle = sub_type ? sub_type + ", " : "";
    newTitle += location ? location + ", " : "";
    newTitle += city;
    setTitle(newTitle);
    setFirstImage(frontImage);
  };

  const listingViewsData = [
    {
      icon: <ImageSvg />,
      textMessage: "By adding good photos",
    },
    {
      icon: <MessageSvg />,
      textMessage: "Add correct details",
    },
    {
      icon: <SealCheckIcon />,
      textMessage: "Verify your property",
    },
  ];

  useEffect(() => {
    const fetch = async () => {
      if (!uuid) return;
      try {
        const response: any = await getPYPData(uuid);
        if (response) {
          extractData(response?.json_form_data);
          setRole(response?.user_type);
          // setData(response.data[0]?.json_form_data);
        }
      } catch (err) {
        console.log("error", err);
      }
    };
    fetch();
  }, [uuid]);
  return (
    <>
      <Header />
      {role === "owner" || role === "property_agent" ? (
        <div className="px-customPaddingMobile mid:flex justify-between lg:px-customPadding mt-8">
          <div className="mid:pr-4">
            <p className="font-openSans font-normal text-web-h3 leading-[38px] text-brand-bgBlack">
              Listing Status
            </p>
            <div className="mt-6 flex flex-col lg:flex-row items-center mid:items-center">
              <GreenCheckIcon className="h-[54px] w-[54px] lg:h-8 lg:w-8 " />
              <p className="font-openSans font-normal lg:font-semibold text-mobile-h2 lg:text-web-h3 leading-9 lg:leading-[38px] text-brand-bgBlack text-center lg:text-start mid:ml-2">
                Congratulations! Your listing is under review!
              </p>
            </div>
            <p className="font-openSans font-semibold text-[20px] leading-7 text-brand-bgBlack mt-[70px]">
              Improve your listing views
            </p>
            <div className="space-y-8 w-full mid:max-w-[569px] mt-6">
              {listingViewsData.map((item) => (
                <div className="flex h-[72px] bg-brand-lightOrange py-4 items-center pl-5">
                  {item?.icon}
                  <p className="ml-3 font-openSans font-normal text-[20px] leading-7">
                    {item?.textMessage}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <PYPDetailsCard2
            uuid={uuid}
            details={data}
            title={title}
            propertyImage={firstImage}
          />
        </div>
      ) : (
        <div className="px-customPaddingMobile lg:px-customPadding ">
          <div className="max-w-[583px] mx-auto mt-6 flex flex-col items-center">
            <GreenCheckIcon className="h-[54px] w-[54px] lg:h-[90px] lg:w-[90px] " />
            <p className="font-spaceGrotesk font-normal text-mobile-h2 lg:text-[34px] leading-9 lg:leading-[43px] text-brand-bgBlack text-center">
              Congratulations! Your listing is under review!
            </p>
          </div>

          <PYPDetailsCard
            uuid={uuid}
            details={data}
            title={title}
            propertyImage={firstImage}
          />
        </div>
      )}

      <Footer />
    </>
  );
};

export default PYPSuccessPage;
